import { useEffect, useState, useTransition } from "react";
import "./App.css";
import ProjectRoutes from "./Routes";
import "./global.css";
import "./index.css";
import NoInternetPopup from "./Popups/Nointernet popup/NoInternetPopup";
import { ToastContainer } from "react-toastify";
import { setSelectedStore, setMasterStore, loginUserSuccess } from "./Redux/Action/loginAction";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import LabelPrinter from "./components/LabelPrint/LabelPrinter";


const App = () => {
  const [isOnline, setIsOnline] = useState(true);
  const dispatch = useDispatch();
  const { i18n } = useTranslation();


  useEffect(() => {
    if (i18n.language === "ar") {
      document.body.classList.add("arabic-font");
    } else {
      document.body.classList.remove("arabic-font");
    }
  }, [i18n.language]);

  useEffect(() => {
    const updateOnlineStatus = () => {
      setIsOnline(window.navigator.onLine);
    };

    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    };
  }, []);

  useEffect(() => {
    const storedMaster = JSON.parse(localStorage.getItem("masterStore"));
    const storedStore = JSON.parse(localStorage.getItem("selectedSubstore"));
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedMaster) dispatch(setMasterStore(storedMaster));
    if (storedStore) dispatch(setSelectedStore(storedStore));
    if (storedUser) dispatch(loginUserSuccess(storedUser));
  }, [dispatch]);


  return (
    <div className="App ">
      {/* <header className="App-header"> */}
      {!isOnline && <NoInternetPopup isVisible={!isOnline} />}
      <ProjectRoutes />
      <ToastContainer />
      <LabelPrinter />
      {/* </header> */}
    </div>
  );
};

export default App;

// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
